import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';

import { isStickyInEditMode, isStickyInViewMode } from './isStickyUtilities';

type UseStickyTableHeaderObserverParams = {
	setIsSticky: React.Dispatch<React.SetStateAction<boolean>>;
	isEditor?: boolean;
	elementToObserve?: HTMLElement | null;
};

export const useStickyTableHeaderObserver = ({
	setIsSticky,
	isEditor,
	elementToObserve,
}: UseStickyTableHeaderObserverParams): void => {
	useEffect(() => {
		if (!fg('confluence_frontend_remove_duplicate_sidebar_logic')) {
			return;
		}

		// Create mutation observer to track class changes
		const stickyTableHeaderObserver = new MutationObserver((mutationsList) => {
			mutationsList.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					const target = mutation.target as HTMLElement;
					if ((isEditor && isStickyInEditMode(target)) || isStickyInViewMode(target)) {
						setIsSticky(true);
					} else {
						setIsSticky(false);
					}
				}
			});
		});

		// Start observing class changes on the parent element
		if (elementToObserve?.parentElement) {
			stickyTableHeaderObserver.observe(elementToObserve.parentElement, {
				attributes: true,
				attributeFilter: ['class'],
			});
		}

		// Clean up all observers
		return () => {
			stickyTableHeaderObserver.disconnect();
		};
	}, [elementToObserve?.parentElement, isEditor, setIsSticky]);
};
